<div
  trackImpression="contentblock-impression"
  [trackImpressionInfo]="rendering"
  [trackImpressionContext]="context"
>
  @if (isManualReview) {
    <wl-review [review]="manualReview" />
  } @else {
    @if (review$ | async; as review) {
      @if (review) {
        <wl-review [review]="review" />
      }
    }
  }
</div>
